import ConfirmationModal from '@enerex/unified-ui-react/ConfirmationModal';

const DeleteRateClassAssociationModal = ({ show, item, type, deleting = false, onCancel, onConfirm }) => (
  <ConfirmationModal
    centered
    show={show}
    onHide={onCancel}
    title={type === 'utility' ? 'Delete Utility Rate Class' : 'Delete Supplier Rate Class'}
    confirmButtonLabel={deleting ? 'Deleting...' : 'Delete'}
    confirmButtonVariant="danger"
    isLoading={deleting}
    onConfirm={onConfirm}
  >
    Are you sure you want to delete <strong>{item?.rateClassName}</strong>?
  </ConfirmationModal>
);

export default DeleteRateClassAssociationModal;
